import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import InventoryList from "app/pages/Inventory/List";


const routesName = "/dashboards/inventory";
const modules = "inventory";

export const inventoryRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
        module: modules
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={InventoryList} />
      },
      {
        path: `${routesName}/add`,
        // element: <Page component={AdminCustomers} />,
      },
      {
        path: `${routesName}/edit`,
        // element: <Page component={EditCloudstratClient} />,
      },
    ],
  },]
